// @ts-nocheck
/* eslint-disable */
export const landscapeLineIcon = {
  data: `<svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.392 10.1802L12.5001 5L19.1667 17.5H1.66675L7.50008 6.66667L9.392 10.1802ZM10.3248 11.8648L12.4895 15.8333H16.389L12.4147 8.38167L10.3248 11.8648ZM4.45711 15.8333H10.5431L7.50008 10.1821L4.45711 15.8333ZM4.58341 6.66667C3.43282 6.66667 2.50008 5.73392 2.50008 4.58333C2.50008 3.43274 3.43282 2.5 4.58341 2.5C5.73401 2.5 6.66675 3.43274 6.66675 4.58333C6.66675 5.73392 5.73401 6.66667 4.58341 6.66667Z" fill="currentColor"/></svg>`,
  name: 'landscape-line' as const,
};
